import { DropdownMenuItem, DropdownMenuSeparator } from "../ui/dropdown-menu";
import { Link } from "react-router-dom";
import { DropdownItem } from "@/types/AppTypes";
import { useAppSelector } from "@/store/hooks";
import { useSignOut } from "@/hooks";

const UserDropdown = () => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const { handleSignOut } = useSignOut();

  const userItems: DropdownItem[] = isAuthenticated
    ? [
        { label: "My Account", path: "/account" },
        { label: "Quick Reorder", path: "/quick-reorder" },
        { label: "Order History", path: "/order-history" },
      ]
    : [
        { label: "Login", path: "/login" },
        { label: "Register", path: "/auth" },
      ];

  return (
    <>
      {userItems.map((item, index) => (
        <DropdownMenuItem
          key={index}
          asChild
          className=" group cursor-pointer hover:outline-none focus:outline-none hover:text-gray-400 "
          onClick={item?.onClick}
        >
          <Link className="group-hover:text-gray-400" to={item?.path}>
            {item?.label}
          </Link>
        </DropdownMenuItem>
      ))}
      {isAuthenticated && user?.has_roles?.includes("seller") ? (
        <></>
      ) : isAuthenticated ? (
        <>
          <DropdownMenuItem
            asChild
            className=" group cursor-pointer hover:outline-none focus:outline-none hover:text-gray-400 "
          >
            <Link className="group-hover:text-gray-400" to="/distributor-registration">
              Become a Distributor
            </Link>
          </DropdownMenuItem>
        </>
      ) : null}
      {isAuthenticated && (
        <>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="cursor-pointer text-red-500 font-medium  hover:outline-none focus:outline-none"
            onClick={handleSignOut}
          >
            Logout
          </DropdownMenuItem>
        </>
      )}
    </>
  );
};

export default UserDropdown;
